// src/pages/RecuperarContrasena.jsx
import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const RecuperarContrasena = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Estado para el correo, errores, éxito y carga
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    const auth = getAuth();
    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess('Se ha enviado un correo para restablecer la contraseña. Por favor, revisa tu bandeja de entrada.');
        setEmail('');
      // Opcional: redirigir al login después de unos segundos
      // setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      console.error(err);
      if (err.code) {
        switch (err.code) {
          case 'auth/invalid-email':
            setError('El correo ingresado no es válido.');
            break;
          case 'auth/user-not-found':
            setError('No se encontró un usuario con ese correo.');
            break;
          case 'auth/network-request-failed':
            setError('Error de red. Verifica tu conexión a Internet.');
            break;
          default:
            setError(err.message || 'Ocurrió un error. Por favor, inténtalo de nuevo.');
        }
      } else {
        setError('Ocurrió un error inesperado. Por favor, inténtalo de nuevo.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <section className="hero-section" id="hero-recuperar">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-right">
              <h1>Recupera tu Contraseña</h1>
              <p className="mb-4">
                Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
              </p>
            </div>
            <div className="col-lg-4" data-aos="fade-left">
              <img src="/assets/img/forgot-password.png" alt="Recuperar Contraseña" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section className="section">
          <div className="container" data-aos="fade-up">
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <form onSubmit={handleSubmit} className="php-email-form">
              <div className="form-group">
                <label htmlFor="email">Correo Electrónico</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Ingresa tu correo"
                  value={email || ''}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="mt-4">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Enviando..." : "Recuperar Contraseña"}
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default RecuperarContrasena;
